import React, { useEffect } from "react";

const PageLoader = (props) => {

    useEffect(() => {
        if (props.loading) {
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.remove('no-scroll');
        }
    }, [props.loading]);


    return (
        <>
            {
                props.loading &&

                <div className={props.loading ? "preloader" : ""}>
                    <div className="preloader-icon"></div>
                    <span>{props.loading ? "Loading..." : ""}</span>
                </div>
            }
        </>
    )
}
export default PageLoader;